import { PropsWithChildren, forwardRef } from "react";

import { cn } from "$/utils/functions/misc.functions";

import ContextMenuProvider from "./ContextMenuProvider";

type ContextMenuProps = {
  handleCloseMenu: () => void;
};

const ContextMenu = forwardRef<
  HTMLDivElement,
  PropsWithChildren<ContextMenuProps>
>(function ContextMenu(
  { children, handleCloseMenu }: PropsWithChildren<ContextMenuProps>,
  ref,
) {
  return (
    <div
      ref={ref}
      className={cn(
        "z-52 fixed left-1/2 top-1/2 min-w-[220px] -translate-x-1/2 -translate-y-1/2 p-[5px]",
      )}
    >
      <ContextMenuProvider handleClose={handleCloseMenu}>
        {children}
      </ContextMenuProvider>
    </div>
  );
});

export default ContextMenu;
